import PropTypes from "prop-types";

const Answer = ({ label, answerId, questionType }) => {
  if (questionType === "check") {
    return (
      <div className="check-box-answer checked">
        <div className="answer-option">
          <input id={answerId} type="checkbox" checked readOnly />
          <label className="answer-option-check-box" htmlFor={answerId}>
            {label}
          </label>
        </div>
      </div>
    );
  }
  if (questionType === "radio") {
    return (
      <div className="radio-button-answer checked">
        <div className="answer-option">
          <input id={answerId} type="radio" checked readOnly />
          <label className="answer-option-radio-btn" htmlFor={answerId}>
            {label}
          </label>
        </div>
      </div>
    );
  }
  return <p>{label}</p>;
};

Answer.propTypes = {
  label: PropTypes.string,
  answerId: PropTypes.number,
  questionType: PropTypes.string,
};

export default Answer;
